import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "side_text1" }, "研修", -1)
const _hoisted_3 = { class: "side_banner1" }
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "banner1" }
const _hoisted_6 = ["src", "alt", "onError"]
const _hoisted_7 = {
  key: 0,
  class: "t1"
}
const _hoisted_8 = { class: "text1" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  key: 0,
  class: "sep1"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "side_text1" }, "Load To Master", -1)
const _hoisted_12 = { class: "side_banner1" }
const _hoisted_13 = ["href"]
const _hoisted_14 = { class: "banner1" }
const _hoisted_15 = ["src", "alt", "onError"]
const _hoisted_16 = {
  key: 0,
  class: "t1"
}
const _hoisted_17 = { class: "text1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.kensyuBannerListData.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("ul", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.kensyuBannerListData, (banner, index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: banner.bannerName
              }, [
                _createElementVNode("a", {
                  href: banner.bannerUrl,
                  target: "_blank"
                }, [
                  _createElementVNode("span", _hoisted_5, [
                    _createElementVNode("img", {
                      src: _ctx.kensyuImageSources[index] + '?v=' + new Date().getTime(),
                      alt: banner.bannerName,
                      onError: ($event: any) => (_ctx.kensyuHandleImageError(index))
                    }, null, 40, _hoisted_6),
                    (_ctx.kensyuImageError[index])
                      ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(banner.bannerName), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("span", _hoisted_8, _toDisplayString(banner.bannerCaption), 1)
                ], 8, _hoisted_4)
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.loadToMasterBannerListData.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          (_ctx.kensyuBannerListData.length > 0)
            ? (_openBlock(), _createElementBlock("hr", _hoisted_10))
            : _createCommentVNode("", true),
          _hoisted_11,
          _createElementVNode("ul", _hoisted_12, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.loadToMasterBannerListData, (banner, index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: banner.bannerName
              }, [
                _createElementVNode("a", {
                  href: banner.bannerUrl,
                  target: "_blank"
                }, [
                  _createElementVNode("span", _hoisted_14, [
                    _createElementVNode("img", {
                      src: 
                _ctx.loadToMasterImageSources[index] + '?v=' + new Date().getTime()
              ,
                      alt: banner.bannerName,
                      onError: ($event: any) => (_ctx.loadToMasterHandleImageError(index))
                    }, null, 40, _hoisted_15),
                    (_ctx.loadToMasterImageError[index])
                      ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(banner.bannerName), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("span", _hoisted_17, _toDisplayString(banner.bannerCaption), 1)
                ], 8, _hoisted_13)
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}